import { IconButton, Snackbar, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import { useSnackbarNotification } from './SnackbarNotificationContext';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    info: {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
    },
    warning: {
      color: 'white',
      backgroundColor: theme.palette.yellow[800],
    },
    success: {
      color: 'white',
      backgroundColor: theme.palette.green[800],
    },
    error: {
      color: 'white',
      backgroundColor: theme.palette.red[800],
    },
    content: {
      display: 'flex',
      alignItems: 'center',
    },
    message: {
      wordWrap: 'break-word',
      maxWidth: 500,
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing(2),
    },
  })
);

const SnackbarNotification = () => {
  const classes = useStyles();
  const {
    autoHideDuration,
    isOpen,
    message,
    type,
    action,
    close,
  } = useSnackbarNotification();

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={isOpen}
      autoHideDuration={autoHideDuration}
      onClose={close}
      message={
        <span id="alert-snackbar" className={classes.content}>
          {
            {
              info: (
                <InfoIcon
                  data-test-id="info-icon"
                  className={clsx(classes.icon, classes.iconVariant)}
                />
              ),
              success: (
                <CheckCircleIcon
                  data-test-id="success-icon"
                  className={clsx(classes.icon, classes.iconVariant)}
                />
              ),
              warning: (
                <WarningIcon
                  data-test-id="warning-icon"
                  className={clsx(classes.icon, classes.iconVariant)}
                />
              ),
              error: (
                <ErrorIcon
                  data-test-id="error-icon"
                  className={clsx(classes.icon, classes.iconVariant)}
                />
              ),
            }[type]
          }
          {typeof message === 'string' ? (
            <Typography variant="body2" className={classes.message}>
              {message}
            </Typography>
          ) : (
            message
          )}
        </span>
      }
      action={
        action || [
          <IconButton key="close" color="inherit" onClick={close}>
            <Close className={classes.icon} />
          </IconButton>,
        ]
      }
      ContentProps={{
        className: classes[type],
      }}
    />
  );
};

export default SnackbarNotification;
